export default "__VITE_ASSET__DXKfdzA1__"